import { useGetAllDealerAddressBrandRegionalManagerQuery, useCreateDealerAddressBrandRegionalManagerMutation, useUpdateDealerAddressBrandRegionalManagerMutation } from '../../../../../api';
import { useGetUserGroupsQuery } from '../../../../../api';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { formatDateForApi } from '../../../../../utils/dateUtils';

import { useState } from 'react';

export const useRegionalManagerData = ({ dealerAddressBrandId, dealerAddress, pageSize = 10, enabled = true }) => {
    const { th } = useLanguage();

    const [pageNumber, setPageNumber] = useState(1);

    const { data: userGroupsResponse } = useGetUserGroupsQuery();

    const {
        data = { items: [], count: 0 },
        isLoading,
        isFetching,
        isError,
        error,
        refetch
    } = useGetAllDealerAddressBrandRegionalManagerQuery(
        {
            addressBrandId: dealerAddressBrandId,
            pageNumber,
            pageSize
        },
        { skip: !enabled }
    );

    const getUserNameById = (id) => {
        return userGroupsResponse?.data?.find((user) => user.id === id)?.name || id;
    };

    const [createRegionalManager] = useCreateDealerAddressBrandRegionalManagerMutation();
    const [updateRegionalManager] = useUpdateDealerAddressBrandRegionalManagerMutation();

    const columns = [
        {
            field: 'userName',
            header: th('customerAddressBrand.tabs.regionalManager.columns.userName'),
            body: (row) => row.userName || getUserNameById(row.userId)
        },
        { field: 'contractStartDate', header: th('customerAddressBrand.tabs.regionalManager.columns.contractStartDate'), bodyField: 'contractStartDate' },
        { field: 'contractEndDate', header: th('customerAddressBrand.tabs.regionalManager.columns.contractEndDate'), bodyField: 'contractEndDate' },

        { field: 'description', header: th('customerAddressBrand.tabs.regionalManager.columns.description') }
    ];

    const save = async (formData) => {
        try {
            if (formData.id) {
                const payload = {
                    id: formData.id,
                    dealerAddressBrandId,
                    siteUseId: dealerAddress.id,
                    userId: Number(formData.userId) || 0,
                    contractStartDate: formData.contractStartDate ? formatDateForApi(formData.contractStartDate) : null,
                    contractEndDate: formData.contractEndDate ? formatDateForApi(formData.contractEndDate) : null,
                    description: formData.description || '',
                    isActive: 1
                };
                await updateRegionalManager(payload).unwrap();
                console.log('✅ Regional Manager güncellendi', payload);
            } else {
                const payload = {
                    dealerAddressBrandId,
                    siteUseId: dealerAddress.id,
                    userId: Number(formData.userId) || 0,
                    contractStartDate: formData.contractStartDate ? formatDateForApi(formData.contractStartDate) : null,
                    contractEndDate: formData.contractEndDate ? formatDateForApi(formData.contractEndDate) : null,
                    description: formData.description || ''
                };
                await createRegionalManager(payload).unwrap();
                console.log('✅ Regional Manager oluşturuldu', payload);
            }
            refetch();
        } catch (err) {
            console.error('❌ Regional Manager kayıt hatası:', err);
        }
    };

    return {
        items: data.items,
        count: data.count,
        isLoading: isLoading || isFetching,
        columns,
        save,
        refetch,
        pageNumber,
        setPageNumber,
        pageSize
    };
};
